import { createContext } from 'react';

interface OverdueContextType {
  showOverdueModal: boolean;
  setShowOverdueModal: (show: boolean) => void;
}

export const OverdueContext = createContext<OverdueContextType>({
  showOverdueModal: false,
  setShowOverdueModal: () => {},
});
